export const FALLBACK_PRIMARY_COLOR = '#1233DF'

export const INPUT_BORDER_DARKEN_MULTIPLIER = 0.3
export const BUTTONS_HOVER_MULTIPLIER = 0.9
export const OLD_BLUE_HEX = '#3598DC'
export const NEW_BLUE_HEX = '#134AD2'

export const SSPX = 8
